import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { enumReporteSeleccionado } from "../../componentes/FuncionesLocales";
import { normalizarEmpresaId } from "../../servicios/empresa";

const empresaIdPersistida = () => {
    localStorage.removeItem("DB");
    localStorage.removeItem("Conexion");
    try {
        return normalizarEmpresaId(localStorage.getItem("EmpresaId"));
    } catch {
        return 0;
    }
};

export const useStoreHome = create((set, get) => {
    return {
        Caducidad: "",
        FechaCaducidad: null,
        CaducidadConsultada: false,
        EmpresaCaducidadId: null,
        CargandoCaducidad: false,
        EmpresaId: empresaIdPersistida(),
        obtenerCaducidad: async () => {
            const EmpresaId = empresaIdPersistida();
            const estado = get();
            if (estado.CaducidadConsultada && estado.EmpresaCaducidadId === EmpresaId) {
                return estado.FechaCaducidad;
            }
            if (estado.CargandoCaducidad && estado.EmpresaCaducidadId === EmpresaId) {
                return null;
            }

            set({
                CargandoCaducidad: true,
                CaducidadConsultada: false,
                EmpresaCaducidadId: EmpresaId,
                FechaCaducidad: null,
            });
            const sParametros = {
                EmpresaId,
            };
            try {
                const data = await _Componentes_WebApiCalls_Post("PISeunLogin/FechaCaducidad", sParametros);
                if (data.error) {
                    return null;
                } else {
                    const dato = data.data?.Dato || "";
                    const [day, month, year] = dato.split("/");
                    const formattedDate = new Date(`${year}-${month}-${day}`);
                    const FechaCaducidad = Number.isNaN(formattedDate.getTime()) ? null : formattedDate;
                    set({
                        Caducidad: dato ? `Su prueba finaliza el ${dato}` : "",
                        FechaCaducidad,
                    });
                    return FechaCaducidad;
                }
            } catch {
                // La caducidad se vuelve a consultar en el siguiente ingreso.
                return null;
            } finally {
                set({ CaducidadConsultada: true, CargandoCaducidad: false });
            }
        },

        
        deviceConsentimiento:
            localStorage.getItem("deviceConsentimiento") !== null
                ? localStorage.getItem("deviceConsentimiento")
                : null,

        deviceInfo:
            localStorage.getItem("deviceInfo") !== null
                ? JSON.parse(localStorage.getItem("deviceInfo"))
                : null,

        setDeviceConsentimiento: (value) => {
            if (value === null) {
                localStorage.removeItem("deviceConsentimiento");
            } else {
                localStorage.setItem("deviceConsentimiento", value);
            }
            set({ deviceConsentimiento: value });
        },

        setDeviceInfo: (info) => {
            try {
                localStorage.setItem("deviceInfo", JSON.stringify(info));
            } catch { /* El almacenamiento puede estar bloqueado por el navegador. */ }
            set({ deviceInfo: info });
        },

        resetConsentimiento: () => {
            localStorage.removeItem("deviceConsentimiento");
            localStorage.removeItem("deviceInfo");
            set({ deviceConsentimiento: null, deviceInfo: null });
        },

        ReportesSeleccionado: enumReporteSeleccionado.INGRESOS,
    };
});
